import { 
	GET_APPROVAL_PROCESSES, 
	GET_APPROVAL_PROCESS,
	CREATE_APPROVAL_PROCESS,
	UPDATE_APPROVAL_PROCESS,
	DESTROY_APPROVAL_PROCESS,
} from "./actions"

export function ApprovalProcessesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_APPROVAL_PROCESSES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_APPROVAL_PROCESS}_FULFILLED`:
		case `${CREATE_APPROVAL_PROCESS}_FULFILLED`:
		case `${UPDATE_APPROVAL_PROCESS}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_APPROVAL_PROCESS}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ApprovalProcessesReducer } from "modules/approval_processes/reducer"

// approval_processes:ApprovalProcessesReducer,
